import React, { useState } from "react";
import { DateTime } from "luxon";
import { Col, Row } from "react-bootstrap";
import { useSessionStore } from "../../../../Stores/SessionStore";
import CannotRechargeWarningModal from "../../../Core/CannotRechargeWarningModal";
import PageTitle from "../../../Core/PageTitle";
import Confirmation from "./Confirmation";
import ServiceGrid from "./Services/ServiceGrid";
import ConfirmAddressModal from "./ConfirmAddressModal";
import SubscriptionChoiceModal from "./SubscriptionChoiceModal";

export default function Recharge() {
	const [confirmingRecharge, showConfirmRecharge] = useState(false);
	const [payingForRecharge, showRechargePayment] = useState(false);
	const [showCannotRechargeModal, setShowCannotRechargeModal] = useState(false);
	const [rechargeDetails, setRechargeDetails] = useState(null);
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [showSubscriptionChoiceModal, setShowSubscriptionChoiceModal] = useState(false);
	const [rechargeIsNotSubscription, setRechargeIsNotSubscription] = useState(false);

	const store = useSessionStore();

	async function handleServiceClicked(category, product) {
		if (store.CustomerDetails === null) {
			await store.LoadCustomerDetails();
		}

		const radiusDetails = store.CustomerDetails?.RadiusDetails;
		if (!radiusDetails) {
			setShowCannotRechargeModal(true);
			return;
		}

		const expiryDate = DateTime.fromISO(radiusDetails.ExpiryDate);
		const activeServiceId = radiusDetails.ServiceId;

		if (
			activeServiceId !== 4 &&
			expiryDate.diffNow("days").days > 5 &&
			product.ServiceId !== activeServiceId
		) {
			setShowCannotRechargeModal(true);
			return;
		}

		setRechargeDetails({ Category: category, Product: product });
		if (product.Period === 31) {
			setShowSubscriptionChoiceModal(true);
			return;
		}

		setRechargeIsNotSubscription(false);
		setShowConfirmationModal(true);
	}

	function handleSubscriptionChoice(isNotSubscription) {
		setRechargeIsNotSubscription(isNotSubscription);
		setShowSubscriptionChoiceModal(false);
		setShowConfirmationModal(true);
	}

	function handleSubscriptionChoiceClose() {
		setShowSubscriptionChoiceModal(false);
		setRechargeDetails(null);
		setRechargeIsNotSubscription(false);
	}

	function handleRechargeConfirm(answer) {
		if(answer === false) {
			setRechargeDetails(null);
			setRechargeIsNotSubscription(false);
			showConfirmRecharge(false);
		} else {
			showConfirmRecharge(false);
			showRechargePayment(true);
		}
	}

	return 	<React.Fragment>
				<PageTitle text={rechargeDetails === null ? "Packages" : "Complete Purchase"}></PageTitle>
				<Row className="bg-white">
					<Col xs={12} md={12} xl={8} className="offset-0 offset-xl-2 pb-4 pl-0 pr-0 pl-md-5 pr-md-5">
						{
							confirmingRecharge === false &&
							<ServiceGrid onServiceClicked={ handleServiceClicked }></ServiceGrid>
						}
						{
							confirmingRecharge && rechargeDetails &&
							<Confirmation
								category={rechargeDetails.Category}
								product={rechargeDetails.Product}
								isNotSubscription={rechargeIsNotSubscription}
								onSubmit={handleRechargeConfirm}
							/>
						}
					</Col>
					<CannotRechargeWarningModal show={ showCannotRechargeModal } onOKClicked={ e => setShowCannotRechargeModal(false) }></CannotRechargeWarningModal>
					<SubscriptionChoiceModal
						show={showSubscriptionChoiceModal}
						onClose={handleSubscriptionChoiceClose}
						onChoose={handleSubscriptionChoice}
					/>
					<ConfirmAddressModal show={ showConfirmationModal } onClose={ (confirmed) => {setShowConfirmationModal(false);showConfirmRecharge(confirmed);} } />
				</Row>
			</React.Fragment>
}